import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import client from '../../api';
import { picState } from '../../features/pic/picSlice';
import DatagridSiberat from '../../components/table/Datagrid';
import { NumericFormat } from 'react-number-format';
import Paging from '../../components/Paging';
import { Icon } from '@iconify/react';

const DataInvoice = () => {
  const { user } = useSelector(state => state.auth);
  const pic = useSelector(picState);
  const [invoceData, setInvoiceData] = useState({
    rowData: [],
    isLoading: false,
    totalPages: 0,
    totalDataAll: 0,
    totalDataPages: 0,
    total_invoices_value: null
  });
  const [activeId, setActiveId] = useState(1);
  const [filterInvoice, setFilterInvoice] = useState('notpaid');
  const [currentInvoicePage, setCurrentInvoicePage] = useState(1);
  const [refreshKey, setRefreshKey] = useState(0);
  const values = [
    { id: 1, text: 'Belum Bayar', val: 'notpaid' },
    { id: 2, text: 'Partial', val: 'partial' },
    { id: 3, text: 'Overdue', val: 'overdue' }
  ];

  const getData = async (
    pageNo = 1,
    filter = null,
    pic = null,
    sizePage = 10
  ) => {
    const response = await client.get(
      `/api/customers/dashboard/invoice?page=${pageNo}&size=${sizePage}&filter=${filterInvoice}&branch=${pic}`,
      {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${user.data.token}`
        }
      }
    );
    return response.data;
  };

  // Compact 2-column structure for narrow panel
  const columns = [
    {
      field: 'invoice',
      headerName: 'Invoice',
      flex: 1,
      minWidth: 0,
      resizable: false,
      sortable: false,
      renderCell: cell => {
        if (cell.row?.total) return null;
        const days = parseInt(cell?.row.ar_overdue);
        const overdue = !Number.isNaN(days) && days < 0;
        return (
          <div className='dashboard-cell dashboard-cell--compact'>
            <p className='dashboard-cell__title'>
              <span className='dashboard-cell__no-inline'>
                {(currentInvoicePage - 1) * 10 + cell.row.key}.
              </span>
              {cell?.row?.inv_no}
            </p>
            <p className='dashboard-cell__meta'>
              {moment(cell?.row?.inv_tgl).format('DD MMM YYYY')}
            </p>
            <span className={`dashboard-badge ${overdue ? 'is-danger' : ''}`}>
              {cell?.row.ar_overdue} Hari
            </span>
          </div>
        );
      }
    },
    {
      field: 'job_cost',
      headerName: 'Nilai',
      width: 118,
      resizable: false,
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      renderCell: cell => (
        <NumericFormat
          value={parseInt(cell?.row.total_invtax ?? 0)}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'Rp '}
          renderText={value => (
            <p className='dashboard-cell__amount dashboard-cell__amount--sm'>
              {value}
            </p>
          )}
        />
      )
    }
  ];

  let rows = [];
  invoceData?.rowData?.map((item, key) =>
    rows.push({
      ...item,
      id: parseInt(item?.id),
      key: key + 1
    })
  );

  const refFilter = useRef();
  const refPic = useRef();
  useEffect(() => {
    setInvoiceData(prevState => ({
      ...prevState,
      rowData: [],
      isLoading: true
    }));
    getData(
      filterInvoice === refFilter.current ? currentInvoicePage : 1,
      filterInvoice,
      pic
    )
      .then(info => {
        const {
          count,
          rowCount,
          rows,
          total_invoices_value,
          totalPages: total_pages,
          currentPage
        } = info;
        setInvoiceData({
          isLoading: false,
          rowData: rows,
          totalPages: total_pages,
          total_invoices_value: total_invoices_value,
          totalDataPages: rowCount,
          totalDataAll: count
        });
        setCurrentInvoicePage(currentPage);
      })
      .catch(() => toast.error('Internal Server Error'));
    refFilter.current = filterInvoice;
    refPic.current = pic;
  }, [currentInvoicePage, filterInvoice, pic, refreshKey]);

  return (
    <div className='dashboard-activity dashboard-activity--invoice'>
      <div className='dashboard-activity__head'>
        <div>
          <div className='dashboard-activity__title-row'>
            <h3 className='dashboard-activity__title'>Invoice</h3>
            <span className='dashboard-activity__count'>
              {invoceData.totalDataAll || 0}
            </span>
          </div>
          <p className='dashboard-activity__subtitle'>
            Perlu ditindaklanjuti
          </p>
          <Link to='/invoice' className='dashboard-activity__link'>
            Lihat semua
            <Icon icon='solar:arrow-right-linear' width={14} />
          </Link>
        </div>
        <div className='dashboard-activity__aside'>
          <div className='dashboard-activity__metric'>
            <p className='dashboard-activity__metric-label'>Total</p>
            <p className='dashboard-activity__metric-value dashboard-activity__metric-value--sm'>
              {invoceData?.total_invoices_value ?? '-'}
            </p>
          </div>
          <button
            type='button'
            className={`dashboard-activity__refresh${
              invoceData.isLoading ? ' is-spinning' : ''
            }`}
            disabled={invoceData.isLoading}
            onClick={() => setRefreshKey(key => key + 1)}
            aria-label='Refresh invoice'>
            <Icon icon='solar:refresh-bold' width={18} />
          </button>
        </div>
      </div>

      <div className='dashboard-activity__filters'>
        <div className='dashboard-activity__chips'>
          {values.map(val => (
            <button
              key={val.id}
              type='button'
              onClick={() => {
                setActiveId(val.id);
                setFilterInvoice(val.val);
              }}
              className={`dashboard-chip ${
                activeId === val.id ? 'is-active' : ''
              }`}>
              {val.text}
            </button>
          ))}
        </div>
      </div>

      <div className='dashboard-activity__body'>
        <DatagridSiberat
          columns={columns}
          loading={invoceData.isLoading}
          rows={rows}
          columnBufferPx={5}
          getRowHeight={() => 'auto'}
          sortingMode={'server'}
          showPagination={true}
          filter_page={true}
          overflowTable={true}
          heightTable={'560px'}
          total={true}
          customPagination={
            <div className='dashboard-activity__footer dashboard-activity__footer--compact'>
              <div
                className={`dashboard-activity__legend ${
                  invoceData.isLoading ? 'is-hidden' : ''
                }`}>
                {invoceData.totalDataAll || 0} entries
              </div>
              <Paging
                count={invoceData?.totalPages}
                page={currentInvoicePage}
                onChange={(e, value) => {
                  setCurrentInvoicePage(value);
                }}
              />
            </div>
          }
        />
      </div>
    </div>
  );
};

export default DataInvoice;
